;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';

interface PlusIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function PlusIcon({ size = 24, ...props }: PlusIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00012 2.5C8.27626 2.5 8.50012 2.72386 8.50012 3V7.5H13.0001C13.2763 7.5 13.5001 7.72386 13.5001 8C13.5001 8.27614 13.2763 8.5 13.0001 8.5H8.50012V13C8.50012 13.2761 8.27626 13.5 8.00012 13.5C7.72398 13.5 7.50012 13.2761 7.50012 13V8.5H3.00012C2.72398 8.5 2.50012 8.27614 2.50012 8C2.50012 7.72386 2.72398 7.5 3.00012 7.5H7.50012V3C7.50012 2.72386 7.72398 2.5 8.00012 2.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
